module.exports = __webpack_public_path__ + "media/images/banners/banner-3-5d90e6cf1a7311c2aa3b2b0c5302e5e8.png";